const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Handle, Position } from 'react-flow-renderer';
const _ = {
    forEach:    require('lodash/forEach'),
    find:       require('lodash/find'),
    map:        require('lodash/map'),
}

const Globals = require('../../../../../app/globals');
import ExpandableWell from '../../common/ExpandableWell';

// This component is shown when playing a course and the flow map of a course is displayed
class SkillNode extends React.Component {
    constructor(props) {
        super(props);
        this.playStore = this.props.data.playStore;
        this.state = this.getStoreState(props);
        this.unsubscribes = [this.playStore.getStore().listen(this.onPlayChange)];
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

	getStoreState=(props)=>{
		const node_id = props.id;
		let { gate, min_gate, max_gate, remediating } = this.playStore.getNodeGateStatus(node_id);
        let prerequisitesSatisfied = this.playStore.getArePrerequisitesSatisfied(node_id);
        return { 
			gate, min_gate, max_gate, remediating,
            prerequisitesSatisfied, 
        };
	}

    onPlayChange=(storeState)=>{
		this.setState(this.getStoreState(this.props));
    }
    

    render() {
        let nodeClasses = "course-node skill-node";
        let progress_percent = 100 * ( this.state.gate - this.state.remediating * 0.5 - this.state.min_gate) / Math.max(1,(this.state.max_gate - this.state.min_gate));
        if (progress_percent < 0) {
            progress_percent = 0;
        }
        else if (progress_percent > 100) {
            progress_percent = 100;
        }

        let progress_text = `progress ${Math.floor(progress_percent)}%`;

        let filterStyle;
        if (this.state.prerequisitesSatisfied) {
            nodeClasses += " available";
        }
        else {
            filterStyle = {filter: 'grayscale(100%)'};
        }
        let imgElement;
        if (this.props.data.img_src) {
            imgElement = <img src={this.props.data.img_src} style={filterStyle}/>
        }
        
        return (
            <div className={nodeClasses}>
                <h1>{this.props.data.name}</h1>
                <div className="node-progress-bar" title={progress_text}>
                    <span className="progress" style={{width: `${progress_percent}%`}}/>
                </div>
                {imgElement}
            </div>
        );
    }
};

export default SkillNode;